const tempGroupRuleValidate = {
  bizNoPrefix: [{ required: true, message: '业务编码不能为空' }],
  tplName: [{ required: true, message: '审批模版名称不能为空' }],
  tplGroupId: [{ required: true, message: '模版组不能为空' }],
  sortNum: [{ required: true, message: '排序不能为空' }, { type: 'number', message: '请输入数字' }],
  applyFrom: { required: true, message: '审批来源不能为空', type: 'number' }
};
const checkDataMap = {
  allwRecallSetDay: 'allowRecall',
  allwAuditSetDay: 'allowEdit',
  allwAuditSetTime: 'allowEdit'
};
const rmMultiOneOrManyMap = {
  one: {
    rmMultiSeqAduit: 0,
    rmMultiAduit: 1
  },
  may: {
    rmMultiSeqAduit: 1,
    rmMultiAduit: 0
  },
  '': {
    rmMultiSeqAduit: 0,
    rmMultiAduit: 0
  }
};
/*
  审批人和发起人是同一个人情况下（默认关闭该配置，开启则选择以下一种）
  1.自动通过
  2.该流程审批、办理节点屏蔽该审批人
*/
const applyAuditMap = {
  // 开启-自动通过
  s1: {
    rmApplyAduitSame: 1,
    allowApplyAuditSame: 1
  },
  // 开启-该流程审批、办理节点屏蔽该审批人
  s2: {
    rmApplyAduitSame: 0,
    allowApplyAuditSame: 0
  },
  // 关闭
  '': {
    rmApplyAduitSame: 0,
    allowApplyAuditSame: 1
  }
};
const applyFormOptions = [
  { name: '全部', value: 0 },
  { name: '仅BPM平台', value: 1 },
  { name: '仅API接口', value: 2 }
];
export { tempGroupRuleValidate, checkDataMap, rmMultiOneOrManyMap, applyAuditMap, applyFormOptions };
